<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("incident_list.title") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="listFilter"
          :options="listOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:listFilter', val)"
          multiple
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("incident.title") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="incidentFilter"
          :options="incidentOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:incidentFilter', val)"
          multiple
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("date.created_at") }}</label>
        <flat-pickr
          :value="createdAtFilter"
          class="form-control"
          @input="(val) => $emit('update:createdAtFilter', val)"
          :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    flatPickr,
    vSelect,
  },
  props: {
    listOptions: {
      type: Array,
      default: null,
    },
    listFilter: {
      type: Array,
      default: null,
    },
    incidentOptions: {
      type: Array,
      default: null,
    },
    incidentFilter: {
      type: Array,
      default: null,
    },
    createdAtFilter: {
      type: String,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
